import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { SearchIndexDocument } from '@jessie/commons';
import { DocumentService, mapToSearchIndexDocuments } from '../../../services/document.service';
import { map, tap } from 'rxjs/operators';
import { DocumentCardComponent } from './document-card/document-card.component';
import { AsyncPipe } from '@angular/common';
import { Dialog } from '@angular/cdk/dialog';
import { DocumentSlideOverComponent } from '../document-slide-over/document-slide-over.component';

@Component({
    selector: 'app-accounting',
    templateUrl: './accounting.component.html',
    imports: [DocumentCardComponent, AsyncPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountingComponent {
  documents$: Observable<SearchIndexDocument[]>;

  searchValue = new BehaviorSubject<string | null>(null);
  limitRows = new BehaviorSubject<boolean>(true);

  constructor(
    private documentService: DocumentService,
    @Inject(Dialog) private dialog: Dialog
  ) {
    this.documents$ = combineLatest([
      this.documentService.getDocumentsNotProcessedByAccountant(),
      this.searchValue.pipe(
        tap((x) => {
          if (x) {
            this.limitRows.next(false);
          }
        })
      ),
    ]).pipe(
      map(([documents, searchValue]) => {
        return searchValue
          ? documents.filter((document) => {
              return (
                document.data.name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0 ||
                (document.data.documentText
                  ? document.data.documentText.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
                  : false)
              );
            })
          : documents;
      }),
      map(mapToSearchIndexDocuments)
    );
  }

  editDocument(documents: SearchIndexDocument[]) {
    this.dialog.open(DocumentSlideOverComponent, { data: { documents: documents } });
  }

  async deleteDocument(documents: SearchIndexDocument[]) {
    await Promise.all(
      documents.map((document) => this.documentService.deleteDocumentByPath(document.path))
    );
  }
}
